import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import * as Sentry from "@sentry/react";
import { AuthProvider, useAuth } from "./auth/AuthProvider";
import { createAppRouter } from "./router";
import { initSentry } from "./sentry";
import "./index.css";

const queryClient = new QueryClient();
const router = createAppRouter(queryClient);
initSentry(router);

function CrashFallback() {
  return (
    <main className="min-h-screen grid place-items-center p-6 text-center">
      <div className="max-w-sm space-y-3">
        <p className="text-slate-600">Something went wrong — please reload the app.</p>
        <button
          onClick={() => window.location.reload()}
          className="rounded-xl bg-teal-600 px-4 py-2 font-semibold text-white"
        >
          Reload
        </button>
      </div>
    </main>
  );
}

function AppRouter() {
  const auth = useAuth();
  if (auth.status === "loading") {
    return <main className="min-h-screen grid place-items-center text-slate-400">Loading…</main>;
  }
  return <RouterProvider router={router} context={{ auth, queryClient }} />;
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<CrashFallback />}>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </QueryClientProvider>
    </Sentry.ErrorBoundary>
  </StrictMode>,
);
